module.exports = __webpack_public_path__ + "img/08n.09a58374.png";